import { HttpErrorResponse } from "@angular/common/http";
import  {   Injectable          }   from "@angular/core";
import  {   CqFileDestination   }   from "src/app/beans/components/cq-file/cq-file-destination.bean";
import { NotifierMessage } from "src/app/enums/notifier/message/notifier.enum";
import { Notifier } from "src/app/enums/notifier/notifier.enum";
import { ErrorManager } from "src/app/managers/error/error.manager";
import { NotifierManager } from "src/app/managers/notifier/notifier.manager";
import  {   RequestManager      }   from "src/app/managers/request/request.manager";
import { UtilsManager } from "src/app/managers/utils/utils.manager";

@Injectable
({
  providedIn: 'root'
})
export class MediaHandler
{

    constructor(
        private _request    :   RequestManager      ,
        private _error      :   ErrorManager        ,
        private _notifier   :   NotifierManager     ,
        private _utils      :   UtilsManager
        ) {}

    public async upload_image(
        token       : string     
    ,   level       : string
    ,   levelid     : number
    ,   type        : string
    ,   code        : string
    ,   file        : File       
    ,   description : string 
    ){

        var resp: any 
        try{
            resp = await this._request.media().upload_image (   token 
                                                            ,   level
                                                            ,   levelid
                                                            ,   type
                                                            ,   code
                                                            ,   file
                                                            ,   description )

            if (this._error.hasError( resp )){
                // MANAGE ERROR
                return this._error.handleCQWebapp ( resp )
            }
                                                    
        }catch( error ){
            
            if( error instanceof HttpErrorResponse){
                const httpError = error as HttpErrorResponse
                this._notifier.show( Notifier.ERROR , httpError.error );
            }

            return undefined
        }

        return  resp.media
    }

    public async recoveryMediaByUUID( 
        uuid: string 
    ){

        var resp: any 
        try{
            resp = await this._request.media().recoveryMediaByUUID (   uuid    )
        }catch( error ){

            console.log(error);
            
        }

        return  resp

    }

    public async recoveryMediaData( 
        token       :   string
    ,   destination :   CqFileDestination
    ){
        var resp: any 
        try{
            resp = await this._request.media().recoveryMediaData    (      
                                                                        token     
                                                                    ,   destination.level   
                                                                    ,   destination.levelid 
                                                                    ,   destination.type    
                                                                    ,   destination.code    )                                                     
            return  resp.media
        }catch( error ){
            console.log(error);
        }
        return null 
    }

    public async deleteByType( 
        token       :   string
    ,   destination :   CqFileDestination
    ){
        var resp: any 
        try{
            resp = await this._request.media().deleteByType         (      
                                                                        token     
                                                                    ,   destination.level   
                                                                    ,   destination.levelid 
                                                                    ,   destination.type    
                                                                    ,   destination.code    )     
                  
        
            return  resp == 1
        }catch( error ){
            console.log(error);
        }
        return null 
    }

}